<div class="details-card-wrapper">
    <!-- heading -->
    <h2>{{ heading() }}</h2>

    @switch (products().loadingState) { @case (LoadingState.Loading) {
    <div class="loader-state">
        <webstore-card-loader></webstore-card-loader>
    </div>
    } @case (LoadingState.Loaded) {
    <div class="details-card">
        <div class="details-card-body">
            <webstore-related-products-carousel [products]="products().response || []"></webstore-related-products-carousel>
        </div>
    </div>
    } @case (LoadingState.Error) {
    <div class="server-error-state">
        <webstore-server-error></webstore-server-error>
    </div>
    } }
</div>